export enum EstadoComunicacoPropriedadeEnum {
    COMMUNICATING = 'COMMUNICATING',
    NOT_COMMUNICATING = 'NOT_COMMUNICATING',
    NEVER_COMMUNICATED = 'NEVER_COMMUNICATED',
    CHECK_WITH_DATE = 'CHECK_WITH_DATE',
}
